// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__8hgOF","fullView":"styles_fullView__3XCrS"};